module.exports = __webpack_public_path__ + "img/web-icon.72084338.png";